import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

export default function Agreement(props) {
    const {value, handleChange} = props;

    const yesButtonClasses = classNames('btn btn-block btn-agreement', {
        'btn-agreement-default': value !== true,
        'btn-agreement-active': value === true
    });

    const noButtonClasses = classNames('btn btn-block btn-agreement', {
        'btn-agreement-default': value !== false,
        'btn-agreement-active': value === false
    });

    return (
        <div className="text-center">
            <div className="form-group smart-questions-subform">
                <div className="col-xs-6">
                    <button className={yesButtonClasses} onClick={() => handleChange(true)}>
                        <i className="fa fa-check btn-icon" /> YES
                    </button>
                </div>
                <div className="col-xs-6">
                    <button className={noButtonClasses} onClick={() => handleChange(false)}>
                        <i className="fa fa-times btn-icon" /> NO
                    </button>
                </div>
            </div>
        </div>
    );
}

Agreement.propTypes = {
    handleChange: PropTypes.func.isRequired,
    value: PropTypes.string
};



// WEBPACK FOOTER //
// ./components/smart_question/agreement.js